module.exports = __webpack_public_path__ + "static/media/advisory.2cb95b57.svg";